import React from 'react';
import EmptyCell from './EmptyCell';

export default urls => {
    if (urls === null || urls.length === 0) {
        return <EmptyCell />;
    }

    return (
        <div className="cell" style={{ textAlign: 'center' }}>
            {urls.map(url => (
                <img className="icon-cell" src={url} alt="icon" />
            ))}
        </div>
    );
};
